<template>
  <div>
    <div class="box">
      <div class="nav">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/highPro1' }">支护监测</el-breadcrumb-item>
          <el-breadcrumb-item>传感器</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="cont">
        <div class="btn" >
        <div class="item" @click="dataSet">预警值设置</div>
        <div class="item" @click="enterDataList">历史数据</div>
      </div>
      <el-table
        :data="list"
        border
        height="68vh"
        style="width: 100%">
        <el-table-column
          type="index"
          label="序号"
          width="80">
        </el-table-column>
        <el-table-column
          prop="name"
          label="传感器名称"
          width="170">
        </el-table-column>
        <el-table-column
          prop="tsSersorImei"
          label="传感器设备号"
          width="190">
        </el-table-column>
        <el-table-column
          prop="online"
          label="设备状态"
          width="180">
          <template slot-scope="scope">
            <i :class="scope.row.online==='在线'?'el-icon-success luse':'el-icon-error red'"></i>
            <span :class="scope.row.online==='在线'?'luse':'red'" style="margin-left: 10px">{{ scope.row.online }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="tsSersorTypeName"
          label="设备类型"
          width="180">
        </el-table-column>
        <el-table-column
          prop="nowValue"
          :label="list[0].tsSersorTypeName=='位移'?'实时数据/mm':list[0].tsSersorTypeName=='压力'?'实时数据/Kg':list[0].tsSersorTypeName=='倾角'?'实时数据/°':''"
          width="180">
          <template slot-scope="scope">
            <span class="lanse" style="margin-left: 10px">{{ scope.row.nowValue }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="warning"
          :label="list[0].tsSersorTypeName=='位移'?'预警值/mm':list[0].tsSersorTypeName=='压力'?'预警值/Kg':list[0].tsSersorTypeName=='倾角'?'预警值/°':''"
          width="230">
          <template slot-scope="scope">
            <span class="lanse" style="margin-left: 10px">{{ scope.row.warning }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="updateDate"
          label="监测日期"
          width="230">
        </el-table-column>
        <el-table-column
          label="操作">
          <template slot-scope="scope">
              <el-button @click="handleClick(scope.row)" type="success" size="mini">编辑</el-button>
              <el-button @click="delItem(scope.row)" type="warning" size="mini">删除</el-button>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      </div>
      <el-dialog
      top="30vh"
        title="编辑"
        :visible.sync="dialogVisible1"
        width="35%"
        >
        <div>
           <div class="row" style="padding-left:32px;margin-bottom:20px">
            传感器名称：<div style="width:70%"><el-input v-model="row1.name"></el-input></div>
          </div>
          <div class="row" style="padding-left:32px;margin-bottom:20px">
            传感器编号：<div style="width:70%"><el-input v-model="row1.tsSersorImei"></el-input></div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible1 = false">取 消</el-button>
          <el-button type="primary" @click="updata">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog
      top="30vh"
        title="预警值设置"
        :visible.sync="dialogVisible"
        width="35%"
        >
        <div>
           <div class="row" style="padding-left:32px;margin-bottom:20px">
            传感器预警值：<div style="width:70%"><el-input v-model="valueSet"></el-input></div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="senserWaringValueSet">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import myHttp from '../../untils/port'
import util from '../../untils/util'
  export default {
     data() {
      return {
        options: [{
          value: '0',
          label: '压力'
        }, {
          value: '1',
          label: '位移'
        }, {
          value: '2',
          label: '倾角'
        }],
        value: '',
        form:{
          name:''
        },
        dialogVisible:false,
        dialogVisible1:false,
        tableData: [{
          date: '1',
          name: '支护监测点1',
          address: '在线'
        }, {
          date: '2',
          name: '王小虎',
          address: 'ts202219603'
        }, {
          date: '3',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }, {
          date: '4',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }, {
          date: '3',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }, {
          date: '4',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }, {
          date: '3',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }, {
          date: '4',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }, {
          date: '3',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }, {
          date: '4',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }],
        list:[],
        row:[],
        row1:[],
        valueSet:'',
        title:'kg',
        
      }
    },
    mounted(){
      this.queryTsDtuSensorList()
    },
    methods:{
      enterDataList(){
        this.$router.push({
          path:'/highProItemList',
          query:{
            projectId:util.session.get('groupId'),
            tsSersorType:this.$route.query.tsSenserType,
            tsDtuId:this.$route.query.tsDtuId
          }
        })
      },
      queryTsDtuSensorList(){
        myHttp.queryTsDtuSensorList({
          tsDtuId:`${this.$route.query.tsDtuId}`,
          tsSenserType:`${this.$route.query.tsSenserType}`
        }).then(res=>{
          if(res.data.code==200){
            console.log(res)
            if(res.data.data.List.length!=0){
              this.list = res.data.data.List
              console.log(this.list)
            }else{
              this.$router.go(-1)
              this.$message({
                message:'暂无数据',
                type:'warning'
              })
            }
          }
        })
      },
      dataSet(){
        this.dialogVisible = true
      },
      senserWaringValueSet(){
        myHttp.senserWaringValueSet({
          tsDtuId:`${this.$route.query.tsDtuId}`,
          tsSenserType:`${this.$route.query.tsSenserType}`,
          warningValue:`${this.valueSet}`
        }).then(res=>{
          if(res.data.code==200){
            this.$message({
              message:`${res.data.msg}`,
              type:'success'
            })
            this.dialogVisible = false
            this.queryTsDtuSensorList()
          }else{
            this.$message({
              message:`${res.data.msg}`,
              type:'warning'
            })
          }
        })
      },
      delItem(index){
        let that = this
        this.$confirm('此操作将删除该传感器, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          myHttp.deleteTsDtuSensorDTU({
            id:index.id,
            updateBy:`${util.session.get('groupId')}`
          }).then(res=>{
              that.$message({
              type: 'success',
              message: `${res.data.msg}`
            })
            that.queryTsDtuSensorList()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
      },
      handleClick(index){
        this.dialogVisible1 = true
        this.row = index
        console.log(this.row)
        this.row1={ ...index }
      },
      updata(){
        let that = this
        myHttp.uptTsDtuSensor({
          tsSersorType:`${this.$route.query.tsSenserType}`,
          updateBy:`${util.session.get('groupId')}`,
          tsSersorImei:this.row1.name,
          name:this.row1.tsSersorImei,
          id:this.row1.id,
          tsDtuId:`${this.$route.query.tsDtuId}`
        }).then(res=>{
          if(res.data.code==200){
            this.queryTsDtuSensorList()
            this.dialogVisible1 = false
            that.$message({
              type: 'success',
              message: `${res.data.msg}`
            })
          }else{
            that.$message({
              message:`${res.data.msg}`,
              type:'warning'
            })
          }
        })
      },
      // 添加传感器
      addList(){
        this.dialogVisible= true
      },
      additem(){
        this.dialogVisible1= true
      }
    }
  }
</script>

<style  scoped>
.box{
  width: 100%;
  height: 80vh;
  padding-left: 0.417vw;
  padding-right: 1.25vw;
}
.nav{
  height: 60px;
  display: flex;
  justify-content: start;
  align-items: center;
  font-family: PingFang-SC-Regular;
	font-size: 18px;
  color: #000000;
}
.btn{
  width: 100%;
  height: 60px;
  display: flex;
  justify-content: end;
  align-items: center;
  margin-bottom: 5px;
}
.btn>.item{
  width: 150px;
	height: 40px;
	background-color: #0b62f0;
	border-radius: 6px;
  font-family: PingFang-SC-Regular;
	font-size: 18px;
	font-weight: normal;
	font-stretch: normal;
  line-height: 40px;
	letter-spacing: 0px;
	color: #ffffff;
  cursor: pointer;
  margin-right: 12px;
}
.btn>.item:hover{
  opacity: 0.7;
}
.luse{
color: rgb(44, 231, 44);
}
.lanse{
  color: rgb(41, 150, 212);
}
.row{
  display: flex;
}
.cont{
  width: 100%;
  height: 79vh;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
}
.red{
  color: rgb(230, 65, 36);
}
.el-breadcrumb{
  font-size: 20px;
}
</style>